import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { classNames } from "../../utils/helpers";
import { onNextFrame } from "../../utils/_private/animation";
import { View } from "../view";
import { AccordionContext } from './Accordion.context';
import s from './Accordion.module.css';
export const AccordionContent = (props) => {
    const { children } = props;
    const { contentId, open, triggerId, variant } = React.useContext(AccordionContext);
    const contentRef = React.useRef(null);
    const mountedRef = React.useRef(false);
    const [animatedHeight, setAnimatedHeight] = React.useState(open ? 'auto' : null);
    const contentClassNames = classNames(s.content, s[`--variant-${variant}`], 
    // TODO: May be a buggy implementation, look into later
    mountedRef.current && animatedHeight !== 'auto' && s['--animated'], open && s['--open']);
    const contentInnerClassNames = classNames(s['content-inner'], s[`--variant-${variant}`]);
    const handleTransitionEnd = (e) => {
        if (e.propertyName !== 'height')
            return;
        setAnimatedHeight(open ? 'auto' : null);
    };
    // TODO: The following is from reshaped; look into validity later
    // Avoid animations happening if component is open by default
    // onNextFrame lets us wait for the component to render first
    React.useEffect(() => {
        onNextFrame(() => {
            mountedRef.current = true;
        });
    }, []);
    React.useEffect(() => {
        const contentEl = contentRef.current;
        if (!contentEl)
            return;
        let targetHeight = 0;
        if (open) {
            contentEl.style.height = 'auto';
            targetHeight = contentEl.clientHeight;
            contentEl.style.height = '0';
        }
        else {
            contentEl.style.height = `${contentEl.clientHeight}px`;
        }
        setAnimatedHeight(targetHeight);
    }, [open]);
    return (_jsx("div", { className: contentClassNames, ref: contentRef, style: animatedHeight !== null ? { height: animatedHeight } : undefined, onTransitionEnd: handleTransitionEnd, "aria-labelledby": triggerId, id: contentId, role: "region", hidden: !open && animatedHeight === null, "data-testid": "st-accordion-content", "aria-hidden": !open, children: _jsx(View, { padding: 6, className: contentInnerClassNames, children: children }) }));
};
